import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { GROUP_STATUS_CONST } from "../../constants";

@Component({
  selector: "student-comp-table-body",
  templateUrl: "./student-comp-table-body.component.html",
  styleUrls: ["./student-comp-table-body.component.scss"],
})
export class StudentCompTableBodyComponent implements OnInit, OnChanges {
  @Input() columns;
  @Input() students;
  @Input() fixedColRowHoveredIndex;

  @Output() rowHoveredEvent = new EventEmitter<any>();

  GROUP_STATUS_CONSTANT;

  groupStatusTooltipMapping = {
    in_group_and_meets_criteria: "Member meets all criteria",
    in_group_but_does_not_meet_criteria:
      "Member does not meet at least one criteria",
    out_of_group_but_meets_criteria:
      "Recommended! Meets criteria, but not group member",
  };

  constructor() {}

  ngOnInit() {
    this.GROUP_STATUS_CONSTANT = GROUP_STATUS_CONST;
  }

  ngOnChanges() {}

  rowHovered(index) {
    this.rowHoveredEvent.emit(index);
  }

  getAriaLabel(student, column) {
    return `${student.firstName} ${student.lastName} ${
      student[column.id].descriptor
    }. ${student[column.id].changeDescriptor}.`;
  }
}
